export const DEFAULT_THEME_ID = "light";
export const THEME_STORAGE_KEY = "tower:theme";
export const THEME_COOKIE_KEY = "tower-theme";
export const THEME_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;
